import { useRecoilValue } from 'recoil';
import { selectedConvoyIdState, showConvoyEvaluationsState } from '../../storage/convoys';
import { ConvoyDetail } from '../convoys/ConvoyDetail';
import { ConvoyEvaluations } from '../convoys/ConvoyEvaluations';
import { ConvoyList } from '../convoys/ConvoyList';
import { FloatingCardsLayout } from '../layout/FloatingCardsLayout';
import { ConvoysProvider } from '../providers/ConvoysProvider';

export function ConvoysPage() {
  const selectedConvoyId = useRecoilValue(selectedConvoyIdState);
  const showConvoyEvaluations = useRecoilValue(showConvoyEvaluationsState);

  const content = showConvoyEvaluations ? <ConvoyEvaluations /> : <ConvoyDetail />;

  return (
    <>
      <ConvoysProvider />
      <FloatingCardsLayout
        contentSize="medium"
        list={<ConvoyList />}
        content={selectedConvoyId !== undefined && content}
      />
    </>
  );
}
